const axios = require("axios")
// ------------ CONFIG -----------------
const BASE_URL = process.env.GATSBY_HEALTH_API // Change this to your real API base
// const BASE_URL = "https://health-ayuervedic.uat.doctorite.ai/"
const JOURNAL_BASE_URL = process.env.GATSBY_JOURNAL_API
// const JOURNAL_BASE_URL = "https://journal-ayuervedic.uat.doctorite.ai/"
const PRE_SIGNED_URL = process.env.GATSBY_PRE_SIGNED_URL
async function fetchPatientAssessments(payload) {
    try {
        const headers = {
            Authorization: JSON.parse(localStorage.getItem("userAuth"))
                ?.access_token,
            "Content-Type": "application/json",
        }
        const [response1, response2] = await Promise.all([
            axios.get(
                `${BASE_URL}mcqdone/findByCreatedBy/${payload}?programId=1`,
                { headers }
            ),
            axios.get(
                `${BASE_URL}mcqdone/findByCreatedBy/${payload}?programId=3`,
                { headers }
            ),
        ])
        let assessments = [
            ...(response1.data.responseData || []),
            ...(response2.data.responseData || []),
        ]
        let s = new Set()
        let uniqueAssessments = []
        for (let ass of assessments) {
            if (s.has(ass.mcqName)) {
            } else {
                s.add(ass.mcqName)
                uniqueAssessments.push(ass)
            }
        }
        const assessmentResponsePromises = uniqueAssessments.map(
            async assessment => {
                if (assessment.url) {
                    console.log(
                        "Fetching assessment response for assessment id:",
                        assessment.id
                    )
                    let bucketName = assessment?.url?.substring(
                        "https://".length,
                        assessment?.url.indexOf(".")
                    )
                    let fileName = decodeURIComponent(
                        assessment?.url?.split("amazonaws.com/")[1]
                    )
                    // console.log(assessment?.url, bucketName, fileName)
                    const res = await fetchAssessmentResponses({
                        bucketName,
                        fileName,
                    })
                    assessment.response = res || []
                    return assessment
                } else assessment.response = []
            }
        )
        await Promise.all(assessmentResponsePromises)
        return assessments
    } catch (error) {
        console.error(`❌ Error fetching in assessments :`, error.message)
        return null
    }
}
async function fetchAssessmentResponses(payload) {
    try {
        const response = await axios.post(PRE_SIGNED_URL, payload)
        const presignedUrl = response.data.body
        let resp = await fetch(presignedUrl) // Fetch from the signed URL
        const data = await resp.json() // Correct way to parse JSON from response
        console.log(data)
        return data || []
    } catch (error) {
        console.error(
            `❌ Error fetching in assessment response:`,
            error.message
        )
        return null
    }
}
async function fetchPatientCareplans(payload) {
    try {
        const headers = {
            Authorization: JSON.parse(localStorage.getItem("userAuth"))
                ?.access_token,
            "Content-Type": "application/json",
        }
        const [response1, response2] = await Promise.all([
            axios.get(
                `${JOURNAL_BASE_URL}caregoal/findByPatientUserId/${payload}?pageNo=0&pageSize=10000&programId=1`,
                { headers }
            ),
            axios.get(
                `${JOURNAL_BASE_URL}caregoal/findByPatientUserId/${payload}?pageNo=0&pageSize=10000&programId=3`,
                { headers }
            ),
        ])
        let careplans = [
            ...(response1.data.responseData || []),
            ...(response2.data.responseData || []),
        ]
        const careActivitiesPromises = careplans.map(async careplan => {
            console.log(
                "Fetching care activities for careplan id:",
                careplan.id
            )
            const res = await fetchCareplanActivities({
                id: careplan.id,
                programId: careplan.programId,
            })
            careplan.activities = res || []
            return careplan
        })
        await Promise.all(careActivitiesPromises)
        return careplans
    } catch (error) {
        console.error(`❌ Error fetching in careplans :`, error.message)
        return null
    }
}
async function fetchCareplanActivities(payload) {
    try {
        const headers = {
            Authorization: JSON.parse(localStorage.getItem("userAuth"))
                ?.access_token,
            "Content-Type": "application/json",
        }
        const response = await axios.get(
            `${JOURNAL_BASE_URL}journal/getActiveJournalBycareGoalId/${payload.id}?programId=${payload.programId}`,
            { headers }
        )
        return response.data.responseData || []
    } catch (error) {
        console.error(`❌ Error fetching in care activities :`, error.message)
        return null
    }
}
async function fetchCallLogs(payload) {
    try {
        const headers = {
            Authorization: JSON.parse(localStorage.getItem("userAuth"))
                ?.access_token,
            "Content-Type": "application/json",
        }
        const [response1, response2] = await Promise.all([
            axios.get(
                `${BASE_URL}callLogs/patient?patientUserId=${payload}&isCall=%22careCall%22&programId=1&pageNo=0&pageSize=10000`,
                { headers }
            ),
            axios.get(
                `${BASE_URL}callLogs/patient?patientUserId=${payload}&isCall=%22careCall%22&programId=3&pageNo=0&pageSize=10000`,
                { headers }
            ),
        ])
        return [
            ...(response1.data.responseData || []),
            ...(response2.data.responseData || []),
        ]
    } catch (error) {
        console.error(`❌ Error fetching in calllogs :`, error.message)
        return null
    }
}
export async function getPatientData(patientdata) {
    let patient = { ...patientdata }
    try {
        const patientAssessmentPromises = [0].map(async p => {
            console.log(
                "Fetching assessment for patient user id:",
                patient.userId
            )
            const res = await fetchPatientAssessments(patient.userId)
            patient.assessments = res || []
            return patient
        })
        const patientCareplanPromises = [0].map(async p => {
            console.log(
                "Fetching careplan for patient user id:",
                patient.userId
            )
            const res = await fetchPatientCareplans(patient.userId)
            patient.careplans = res || []
            return patient
        })
        const patientCallLogPromises = [0].map(async p => {
            console.log(
                "Fetching callLogs for patient user id:",
                patient.userId
            )
            const res = await fetchCallLogs(patient.userId)
            patient.callLogs = res || []
            return patient
        })
        await Promise.all(patientAssessmentPromises)
        await Promise.all(patientCareplanPromises)
        await Promise.all(patientCallLogPromises)
        console.log(patient, "patientdataaaaaaaaaaa")
        const headers = {
            Authorization: JSON.parse(localStorage.getItem("userAuth"))
                ?.access_token,
            "Content-Type": "application/json",
            ServiceSource: "saas",
        }
        let url = process.env.GATSBY_QDRANT_URL + "insert_multiple_chunks"
        axios.post(url, patient, { headers })
    } catch (e) {
        console.log(e, "eeeeee")
    }
}
